import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  privacyRequestListParams,
  privacyRequestListQueryOptions,
  privacyRequestListSearchSchema,
  PrivacyRequestsPage,
} from '@/features/privacy-requests';

export const Route = createFileRoute('/_authed/_active/s/$storeId/privacy-requests')({
  staticData: { crumb: 'common:nav.privacyRequests' },
  // A function, not the schema itself: the schema's input would make every key required on the
  // customers feature's links here, which pass no search.
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) =>
    privacyRequestListSearchSchema.parse(search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'customers.read');
  },
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...privacyRequestListQueryOptions(params.storeId, privacyRequestListParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined);
    // Filter, sort and page changes on the list must not wait for the fetch, or a second pick in
    // the filter would build on the stale URL. The page's own query shows the previous rows.
    if (cause !== 'stay') await prefetch;
  },
  component: PrivacyRequestsPage,
});
